import React from "react";
import Modal from "@material-ui/core/Modal";
import styles from "./styles.module.css";
import TextField from "@material-ui/core/TextField";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import axios from "axios";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Dialog from "@material-ui/core/Dialog";
import { connect } from "react-redux";
import SelectComp from "../../utils/Select/SelectComp";

const ConfProduct = (props) => {
  const [formData, setFormData] = React.useState({
    userId: "",
    userName: "",
    contactNum: "",
    userType: "Customer",
    email: "",
    password: "",
    userAddress: "",
  });
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState({
    userName: false,
    contactNum: false,
    email: false,
    password: false,
    userAddress: false,
  });

  React.useEffect(() => {
    if (props.type == "EDIT") {
      setFormData({
        ...formData,
        ...props.userData,
        userId: props.userData._id,
      });
    }
  }, [props.userData]);

  const validate = () => {
    let validData = true;
    let error = {
      userName: false,
      contactNum: false,
      email: false,
      password: false,
      userAddress: false,
    };
    setErr({ ...err, ...error });
    Object.keys(error).map((key) => {
      if (key != "password" && formData[key] == "") {
        error[key] = "Field cannot be empty";
        validData = false;
      }
      if (key == "contactNum" && formData[key].toString().length != 10) {
        error[key] = "Enter Valid Phone Number";
        validData = false;
      }
      if (password == "") {
        error["password"] = "Password Field cannot be empty";
      }
    });
    setErr({ ...error });

    return validData;
  };

  // SUBMIT
  const onSubmit = () => {
    if (validate()) {
      setLoading(true);
      const url = props.type == "EDIT" ? "/editUserApi" : "/addUserApi";

      axios({
        method: "post",
        url: url,
        data: {
          ...formData,
          password: password,
        },
      })
        .then((res) => {
          if (res.data.success) {
            setFormData({
              userId: "",
              userName: "",
              contactNum: "",
              userType: "ADMIN",
              email: "",
              password: "",
              userAddress: "",
            });
            props.onDone();
            setLoading(false);
            props.setAlert("Succesfully Done");
          } else {
            setLoading(false);
            props.setAlert("Something went wrong !Try Again");
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          props.setAlert("Something went wrong !Try Again");
        });
    }
  };

  let btnText = props.type == "EDIT" ? "Update User" : "Add User";
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      scroll={"paper"}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <div className={styles.container}>
        <div className={styles.containerContent}>
          <div className={styles.header}>
            <h1>{btnText}</h1>
            <IconButton onClick={props.onClose}>
              <CloseRoundedIcon />
            </IconButton>
          </div>

          <h2>Details</h2>

          <div className={styles.content}>
            <div className={styles.row}>
              <TextField
                variant="outlined"
                className={styles.textField}
                label="User Name"
                value={formData.userName}
                onBlur={(e) =>
                  setFormData({ ...formData, userName: e.target.value.trim() })
                }
                onChange={(e) =>
                  setFormData({ ...formData, userName: e.target.value })
                }
                error={err.userName}
                helperText={err.userName}
              />

              <TextField
                variant="outlined"
                className={styles.textField}
                label="Email"
                value={formData.email}
                onBlur={(e) =>
                  setFormData({ ...formData, email: e.target.value.trim() })
                }
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                error={err.email}
                helperText={err.email}
              />
            </div>

            <div className={styles.row}>
              <TextField
                variant="outlined"
                className={styles.textField}
                label="Contact"
                type="text"
                value={formData.contactNum}
                onBlur={(e) =>
                  setFormData({
                    ...formData,
                    contactNum: e.target.value.replace(/\D/, "").trim(),
                  })
                }
                onChange={(e) => {
                  e.target.value.length <= 10 &&
                    setFormData({
                      ...formData,
                      contactNum: e.target.value.replace(/\D/, ""),
                    });
                }}
                error={err.contactNum}
                helperText={err.contactNum}
              />

              <TextField
                variant="outlined"
                type="password"
                className={styles.textField}
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={err.password}
                helperText={err.password}
              />
            </div>

            <div className={styles.row}>
              <TextField
                variant="outlined"
                className={styles.textField}
                label="User Addrerss"
                value={formData.userAddress}
                onBlur={(e) =>
                  setFormData({
                    ...formData,
                    userAddress: e.target.value.trim(),
                  })
                }
                onChange={(e) =>
                  setFormData({ ...formData, userAddress: e.target.value })
                }
                error={err.userAddress}
                helperText={err.userAddress}
              />

              <SelectComp
                variant="outlined"
                className={styles.textField}
                label="User Type"
                value={formData.userType}
                onChange={(e) =>
                  setFormData({ ...formData, userType: e.target.value })
                }
                options={[
                  "Customer",
                  "Warehouse",
                  "Manufacturing",
                  "Inventory",
                  "Chief Executives",
                  "sales",
                ]}
                values={[
                  "Customer",
                  "Warehouse",
                  "Manufacturing",
                  "Inventory",
                  "Chief Executives",
                  "sales",
                ]}
              />
            </div>
          </div>

          <Divider />

          <div className={styles.footer}>
            {loading ? (
              <Button variant="contained" color="secondary">
                Loading....
              </Button>
            ) : (
              <Button variant="contained" color="secondary" onClick={onSubmit}>
                {btnText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
});
export default connect(mapStateToProps)(ConfProduct);
